import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRollupDotJsComponent } from './simple-icons-rollup-dot-js.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRollupDotJsComponent ],
    exports:      [ SimpleIconsRollupDotJsComponent ],
    bootstrap:    []
})
export class SimpleIconsRollupDotJsModule {}
